import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Toast, ToastHeader } from 'reactstrap';
import PropTypes from 'prop-types';

const ConfirmationToast = ({
    autoClose,
    autoCloseDelay,
    icon,
    isFailed,
    isOpen,
    message,
    toggle
}) => {

    useEffect(() => {
        if (isOpen && autoClose && autoCloseDelay) {
            const toastTimeout = setTimeout(() => {
                if (isOpen) {
                    toggle();
                }
            }, autoCloseDelay);
            return () => clearTimeout(toastTimeout);
        }
    }, [isOpen]);

    return (
        <Toast
            className={`confirmation-toast-container ${!isFailed ? "toast-msg-success" : "toast-msg-failure"}`}
            isOpen={isOpen}
        >
            <ToastHeader
                icon={icon}
                toggle={() => toggle()}
            >
                {message &&
                    message
                }
            </ToastHeader>
        </Toast>
    );
}

ConfirmationToast.defaultProps = {
    autoClose: false,
    autoCloseDelay: 6000,
    icon: null,
    isFailed: false,
    isOpen: false,
    message: "",
    toggle: () => ({})
};

ConfirmationToast.propTypes = {
    autoClose: PropTypes.bool,
    autoCloseDelay: PropTypes.number,
    icon: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.element
    ]),
    isFailed: PropTypes.bool,
    isOpen: PropTypes.bool,
    message: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.element
    ]),
    toggle: PropTypes.func
};

export default connect()(ConfirmationToast);